<template>
  <yxt-form
    ref="targetform"
    :show-message="true"
    :hide-required-asterisk="true"
    :model="value"
    :inline="true"
    class="target-rule"
  >
    <yxt-form-item
      size="small"
      prop="id"
      :error="
        value.state === 1 || value.state === 2 || value.state === 3 ? ' ' : ''
      "
      :rules="{
        required: true,
        message: isDataModel
          ? $t('pc_spmodel_target_b_53')
          : $t('pc_spmodel_biz_4'),
        trigger: ['blur', 'change']
      }"
    >
      <yxt-select
        v-model="value.id"
        @change="chooseFn1($event)"
        :placeholder="$t('pc_spmodel_biz_select')"
        filterable
        clearable
        size="small"
        class="yxt-dimension-select mr12"
      >
        <yxt-option
          v-for="(option, j) in type1"
          :key="j"
          v-show="option.disabled === 0"
          :disabled="option.disabled === 1"
          :label="option.name"
          :value="option.id"
        />
      </yxt-select>
    </yxt-form-item>
    <template v-if="value" v-for="(it, k) in value.operators">
      <yxt-form-item
        size="small"
        :prop="'operators.' + k + '.operateType'"
        :rules="{
          required: true,
          message: $t('pc_spmodel_biz_2'),
          trigger: ['blur', 'change']
        }"
      >
        <!--           v-if="[0, 1, 2, 3, 4, 5].includes(Number(value.columnType))" -->
        <yxt-select
          v-model="it.operateType"
          @change="chooseFn11(k, $event, value.columnType)"
          :placeholder="$t('pc_spmodel_biz_select')"
          filterable
          clearable
          size="small"
          class="mr12 yxt-dimension-select"
        >
          <yxt-option
            v-for="(option, j) in symbolList[value.columnType]"
            :key="j"
            :label="$t(option.operatorCnName)"
            :value="option.operateType"
          />
        </yxt-select>
      </yxt-form-item>
      <!-- 第四层 -->

      <yxt-form-item
        size="small"
        v-if="Number(value.columnType) === 1"
        :prop="'operators.' + k + '.value'"
        :rules="{
          required: true,
          message: isDataModel
            ? $t('pc_spmodel_biz_5')
            : $t('pc_spmodel_biz_6'),
          trigger: ['blur', 'change']
        }"
      >
        <yxt-input
          v-model="it.value"
          maxlength="50"
          size="small"
          class="yxt-dimension-input mr12"
          :placeholder="$t('pc_spmodel_pl_dimen_8')"
        ></yxt-input>
      </yxt-form-item>
      <yxt-form-item
        size="small"
        v-if="
          Number(it.operateType) !== 20 &&
            (Number(value.columnType) === 2 || Number(value.columnType) === 3)
        "
        :prop="'operators.' + k + '.value'"
        :rules="{
          required: true,
          message: isDataModel
            ? $t('pc_spmodel_biz_7')
            : $t('pc_spmodel_biz_8'),
          trigger: ['blur', 'change']
        }"
      >
        <yxt-input-number
          size="small"
          :max="999999999"
          style="max-width: 148px; min-width: 124px"
          class="yxt-dimension-input mr12"
          v-model="it.value"
        ></yxt-input-number>
      </yxt-form-item>

      <template
        v-if="
          Number(it.operateType) === 20 &&
            (Number(value.columnType) === 2 || Number(value.columnType) === 3)
        "
      >
        <yxt-form-item
          size="small"
          :prop="'operators.' + k + '.values[0]'"
          style="display: inline-block"
          :rules="{
            required: true,
            message: isDataModel
              ? $t('pc_spmodel_biz_5')
              : $t('pc_spmodel_biz_6'),
            trigger: ['blur', 'change']
          }"
        >
          <yxt-input-number
            style="max-width: 148px; min-width: 124px"
            size="small"
            :max="999999999"
            class="yxt-dimension-input mr12"
            v-model="it.values[0]"
          ></yxt-input-number>
        </yxt-form-item>

        <span style="vertical-align: middle; line-height: 32px" class="ml4"
          >{{ $t('pc_spmodel_the_bet') }}</span
        >
        <yxt-form-item
          size="small"
          :prop="'operators.' + k + '.values[1]'"
          style="display: inline-block"
          :rules="{
            required: true,
            message: isDataModel
              ? $t('pc_spmodel_biz_5')
              : $t('pc_spmodel_biz_6'),
            trigger: ['blur', 'change']
          }"
        >
          <yxt-input-number
            style="max-width: 148px; min-width: 124px"
            :max="999999999"
            class="ml4 yxt-dimension-input"
            size="small"
            v-model="it.values[1]"
          ></yxt-input-number>
        </yxt-form-item>

        <span style="vertical-align: middle; line-height: 32px" class="ml4"
          >{{ $t('pc_spmodel_the_betw') }}</span
        >
      </template>

      <yxt-form-item
        size="small"
        v-if="
          (Number(value.columnType) === 4 || Number(value.columnType) === 5) &&
            Number(it.operateType) !== 20
        "
        :prop="'operators.' + k + '.value'"
        :rules="{
          required: true,
          message: $t('pc_spmodel_biz_9'),
          trigger: ['blur', 'change']
        }"
      >
        <yxt-date-picker
          v-model="it.value"
          size="small"
          type="date"
          class="yxt-dimension-date mr12"
          value-format="yyyy-MM-dd"
          :placeholder="$t('pc_spmodel_biz_date')"
        >
        </yxt-date-picker>
      </yxt-form-item>

      <template
        v-if="
          (Number(value.columnType) === 4 || Number(value.columnType) === 5) &&
            Number(it.operateType) === 20
        "
      >
        <yxt-form-item
          size="small"
          :prop="'operators.' + k + '.values[0]'"
          style="display: inline-block"
          :rules="{
            required: true,
            message: $t('pc_spmodel_biz_9'),
            trigger: ['blur', 'change']
          }"
        >
          <yxt-date-picker
            v-model="it.values[0]"
            size="small"
            type="date"
            class="yxt-dimension-date mr12"
            value-format="yyyy-MM-dd"
            :placeholder="$t('pc_spmodel_biz_date')"
          >
          </yxt-date-picker>
        </yxt-form-item>
        <span style="vertical-align: middle; line-height: 32px" class="ml4"
          >{{ $t('pc_spmodel_the_bet') }}</span
        >
        <yxt-form-item
          size="small"
          :prop="'operators.' + k + '.values[1]'"
          style="display: inline-block"
          :rules="{
            required: true,
            message: $t('pc_spmodel_biz_9'),
            trigger: ['blur', 'change']
          }"
        >
          <yxt-date-picker
            v-model="it.values[1]"
            size="small"
            type="date"
            class="ml4 yxt-dimension-date"
            value-format="yyyy-MM-dd"
            :placeholder="$t('pc_spmodel_biz_date')"
          >
          </yxt-date-picker>
        </yxt-form-item>

        <span style="vertical-align: middle; line-height: 32px" class="ml4"
          >{{ $t('pc_spmodel_the_betw') }}</span
        >
      </template>
      <yxt-form-item
        size="small"
        v-if="
          Number(value.columnType) === 0 &&
            [1, 2, 3, 4, 5, 6].includes(Number(it.operateType))
        "
        :prop="'operators.' + k + '.value.id'"
        :error="it.state === 4 ? ' ' : ''"
        :key="it.value.id"
        :rules="{
          required: true,
          message: isDataModel
            ? $t('pc_spmodel_pl_value2')
            : $t('pc_spmodel_pl_value3'),
          trigger: ['blur', 'change']
        }"
      >
        <yxt-select
          v-model="it.value.id"
          @change="chooseFn22(k, $event)"
          :placeholder="$t('pc_spmodel_biz_select')"
          filterable
          clearable
          size="small"
          class="yxt-dimension-input mr12"
        >
          <yxt-option
            v-for="(opt, l) in labervalue"
            :label="opt.label"
            :key="l"
            :value="opt.id"
          />
        </yxt-select>
      </yxt-form-item>

      <yxt-form-item
        size="small"
        v-if="[7, 8, 9].includes(Number(it.operateType))"
        :prop="'operators.' + k + '.values'"
        :error="it.state === 4 ? ' ' : ''"
        :key="it.operateType"
        :rules="[
          {
            type: 'array',
            required: true,
            message: isDataModel
              ? $t('pc_spmodel_pl_value2')
              : $t('pc_spmodel_pl_value3'),
            trigger: ['blur', 'change']
          }
        ]"
      >
        <yxt-select
          v-model="it.values"
          :key="it.operateType"
          ref="muselect"
          @change="chooseFn22(k, $event)"
          :placeholder="$t('pc_spmodel_biz_select')"
          multiple
          filterable
          collapse-tags
          clearable
          size="small"
          class="w216 mr12"
        >
          <yxt-option
            v-for="(opt, l) in labervalue"
            :label="opt.label"
            :key="l"
            :value="opt.id"
          />
        </yxt-select>
      </yxt-form-item>
    </template>
  </yxt-form>
</template>

<script>
import { symbolList } from './enum';
export default {
  name: 'TargetRule',
  data() {
    return {
      symbolList,
      labervalue: []
    };
  },
  props: {
    value: {
      type: Object,
      default: {}
    },
    uselocalStorage: {
      type: Boolean,
      default: false
    },
    type1: {
      type: Array,
      default: []
    },
    isDataModel: {
      // 为建立指标规则设立的数据规则模式
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.changeoperators();
    // 处理先渲染value后渲染option时候的回显bug
    if (this.value && this.value.operators) {
      this.value.operators.forEach(item => {
        if (
          item.value &&
          Array.isArray(item.value) &&
          Number(item.operateType) !== 20 // 排除区间模式下的values
        ) {
          let valuearry = [];
          let state = 0;
          item.value.forEach(obj => {
            valuearry.push(obj.id);
            if (obj.state !== 0) {
              state = obj.state;
            }
          });
          setTimeout(() => {
            item.values = valuearry;
          });
          item.state = state;
        } else if (
          Number(this.value.columnType) === 0 &&
          [1, 2, 3, 4, 5, 6].includes(Number(item.operateType))
        ) {
          item.state = item.value.state;
        }
      });
    }
  },
  watch: {
    type1: {
      handler() {
        // 处理默认赋值时候的下拉选项问题
        if (this.type1.length > 0 && this.value) {
          this.type1.forEach(item => {
            if (this.value.id === item.id) {
              this.labervalue = item.enums;
            }
          });
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    changeoperators() {
      // let newValue = JSON.parse(JSON.stringify(this.value));
      if (this.value.operators.length > 1) {
        this.value.operators = [
          {
            operateType: 20,
            operatorCnName: 'pc_spmodel_eq_14',
            values: [
              this.value.operators[0].value,
              this.value.operators[1].value
            ]
          }
        ];
      }
      this.$emit('update:value', this.value);
    },
    chooseFn1(i) {
      let j = {};
      this.type1.forEach(item => {
        if (item.id === i) {
          j = item;
        }
      });
      let newValue = JSON.parse(JSON.stringify(this.value));
      newValue.id = j.id;
      newValue.name = j.name;
      newValue.description = j.description;
      newValue.columnType = Number(j.columnType);
      newValue.operators[0].operateType = '';
      newValue.operators[0].operatorCnName = '';
      if (Number(j.columnType) === 1) {
        newValue.operators[0].value = '';
      } else {
        newValue.operators[0].value = [];
      }

      newValue.operators[0].values = [];
      newValue.state = 0;
      this.labervalue = j.enums;
      this.$emit('update:value', newValue);
    },

    // columnType: 0  operateType为1，2，3，4，5，6    格式为： { name: '', id: null}
    // columnType: 0  operateType为7,8,9              格式为： [{ name: '', id: null}]
    // columnType: 1,2,3,4                            格式为： 123  或者 '23123123'
    chooseFn22(k, j) {
      let newValue = JSON.parse(JSON.stringify(this.value));
      if (Number(newValue.columnType) === 0) {
        if (
          [1, 2, 3, 4, 5, 6].includes(Number(newValue.operators[k].operateType))
        ) {
          let jother = {};
          // 循环匹配勾选上的对象
          this.labervalue.forEach(item => {
            console.log(typeof j);
            console.log(typeof item.id);
            console.log(item.id === j);
            if (item.id === j) {
              jother = {
                name: item.label,
                id: item.id
              };
            }
          });
          newValue.operators[k].value = jother;
        } else {
          if (Array.isArray(j)) {
            let jother = [];
            // 双重循环匹配勾选上的对象
            this.labervalue.forEach(item => {
              j.forEach(other => {
                if (item.id === other) {
                  jother.push({
                    name: item.label,
                    id: item.id
                  });
                }
              });
            });
            newValue.operators[k].value = jother;
          }
        }
      }
      this.$emit('update:value', newValue);
      console.log(this.value);
    },
    chooseFn11(k, j, columnType) {
      // symbolList[value.columnType]
      let newValue = JSON.parse(JSON.stringify(this.value));
      if ([7, 8, 9].includes(Number(j))) {
        newValue.operators[k].value = [{ name: '', id: null }];
        newValue.operators[k].values = [];
      } else if ([20].includes(Number(j))) {
        newValue.operators[0].values = ['', ''];
      } else if (
        Number(columnType) === 0 &&
        [1, 2, 3, 4, 5, 6].includes(Number(j))
      ) {
        newValue.operators[k].value = {};
      } else {
        newValue.operators[k].value = '';
      }
      let operatorCnName = '';
      this.symbolList[columnType].forEach(item => {
        if (item.operateType === j) {
          operatorCnName = item.operatorCnName;
        }
      });
      newValue.operators[k].operatorCnName = operatorCnName;
      newValue.operators[k].operateType = j;
      this.$emit('update:value', newValue);
    },
    validateFn() {
      return this.$refs.targetform.validate();
    }
  }
};
</script>
<style lang="scss" scoped>
.target-rule {
  display: inline-block;
  vertical-align: top;
}

.w216 {
  width: 216px;
}

.yxt-dimension-select {
  width: 114px;
}

.yxt-dimension-date,
.yxt-dimension-input {
  width: 124px;
}
</style>
